export default {
	nameMap: {
		"title": "标题",
		"lang": "适用语言",
		"contents": "内容",
		"_id": "数据ID",
		"id": "编号",
		"date": "时间戳",
		"markdown": "富文本",
		"image": "图片",
		"link": "链接",
		"synopsis": "简介",
		"details": "详细信息",
		"name": "名称",
		"icon": "图标",
		"full_name": "完整名称"
	},
	componentMap: {
		"title": "text-input",
		"lang": "lang-picker",
		"contents": "array-button",
		"_id": "static-label",
		"id": "text-input",
		"date": "date-picker",
		"markdown": "markdown-editor",
		"image": "image-picker",
		"link": "link-picker",
		"synopsis": "text-area",
		"details": "text-input",
		"name": "text-input",
		"icon": "text-input",
		"full_name": "text-input"
	},
	pick(keys) {
		return Object.keys(this.nameMap)
			.filter(key => keys.has(key))
			.reduce((res, key) => (res[key] = this.nameMap[key], res), {});
	},
	getComponent(fieldName) {
		return this.componentMap[fieldName] ?? "div"
	}
}